import { DraftGroup } from "./draftState";

interface CustomGroupChain {
    names: string[];
    ids: string[];
}

// Walk the custom group chain from a starting parentGroupId up to the top-level
// custom group, returning names + ids ordered shallowest → deepest. A visited
// guard breaks cyclic/dangling chains so malformed data can't infinite-loop.
export const resolveCustomGroupChain = (
    parentGroupId: string | null,
    groupsById: Map<string, DraftGroup>,
): CustomGroupChain => {
    const names: string[] = [];
    const ids: string[] = [];
    const visited = new Set<string>();
    let currentId = parentGroupId;
    while (currentId) {
        if (visited.has(currentId)) {
            break;
        }
        visited.add(currentId);
        const group = groupsById.get(currentId);
        if (!group) {
            break;
        }
        names.unshift(group.name);
        ids.unshift(group.id);
        currentId = group.parentGroupId;
    }
    return { names, ids };
};
